// api.js
import axios from 'axios';

const BASE_URL = 'https://ai.kesifaraci.com/service/api';
const BASE_URL2 = 'http://localhost:8051/api';

// Response Ekleme
export const insertMessage = async (responseData) => {
    try {
        const response = await axios.post(`${BASE_URL}/insertResponse`, responseData);
        return response.data;
    } catch (error) {
        console.error('Error inserting response:', error);
        // Hata olduğunda uyarıyı göster
        alert("Uzun bekleme süresinden dolayı hata oluştu. Sayfa yüklenmedi. Sorgunuzun sonucuna 'Sorgularım' menüsünden sorgunuza tıklayarak ulaşabilirsiniz.");
        // Kullanıcıyı ana sayfaya yönlendir
        window.location.href = "https://ai.kesifaraci.com/";
        // Hata fırlatmak isteyebilirsiniz, ancak bu durumda sayfa yüklenecek ve hata mesajı gösterilecektir
        throw error;
    }
};


// Response Ekleme
export const getResponse = async (id) => {
    try {
        const response = await axios.get(`${BASE_URL}/getResponse/`+id);
        return response;
    } catch (error) {
        console.error('Error inserting response:', error);
        // Hata olduğunda uyarıyı göster
        alert("Uzun bekleme süresinden dolayı hata oluştu. Sayfa yüklenmedi. Sorgunuzun sonucuna 'Sorgularım' menüsünden sorgunuza tıklayarak ulaşabilirsiniz.");
        // Kullanıcıyı ana sayfaya yönlendir
        window.location.href = "https://ai.kesifaraci.com/";
        // Hata fırlatmak isteyebilirsiniz, ancak bu durumda sayfa yüklenecek ve hata mesajı gösterilecektir
        throw error;
    }
};



// Chat Ekleme
export const createChatSession = async (questionData) => {
    try {
        const response = await axios.post(`${BASE_URL}/questions`, questionData);
        return response.data;
    } catch (error) {
        console.error('Error inserting question:', error);
        throw error;
    }
};


export const getMessageDetails = async (id) => {
    try {
        const response = await axios.get(`${BASE_URL}/messages/${id}/details`);
        return response.data;
    } catch (error) {
        console.error('Error fetching message details:', error);
        throw error;
    }
};

// Response Güncelleme
export const updateResponse = async (id, responseData) => {
    try {
        const response = await axios.put(`${BASE_URL}/responses/${id}`, responseData);
        return response.data;
    } catch (error) {
        console.error('Error updating response:', error);
        throw error;
    }
};

export const getmessagebyId = async (messageId) => {
    try {
        const response = await axios.get(`${BASE_URL}/messages/${messageId}/full`);
        
        return response.data;
    } catch (error) {
        console.error('Error fetching message details:', error);
        throw error;
    }
};

// Belirli bir Chat ID'ye göre Response Getirme
export const getResponsesByChatId = async (chatId) => {
    try {
        const response = await axios.get(`${BASE_URL}/responses/chat/${chatId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching responses by chatId:', error);
        throw error;
    }
};